import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { integrations: () => import('./IntegrationsPage.vue') },
  routes: [{
    path: '/integrations/docs',
    component: () => import('./ApiDocsPage.vue'),
    meta: { perm: 'api.manage', navKey: 'integrations' },
  }],
} satisfies FeatureRoutes
